import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { Label } from "recharts";

const CompleteTaskModal = ({ show, close, onSubmit, completeTaskInfo }) => {


    const initialState = {
        remark: "",
        actualHours: "",
        actualMinutes: "",
    };

    const [formData, setFormData] = useState(initialState);

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (!show) {
            setFormData(initialState);
            setErrors({});
        }
    }, [show]);

    // handle change
    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    // validation
    const validateForm = () => {

        let tempErrors = {};
        let isValid = true;

        // remark
        if (!formData.remark.trim()) {
            tempErrors.remark = "Remark is required";
            isValid = false;
        }

        // hours
        if (formData.actualHours === "") {
            tempErrors.actualHours = "Actual Hours is required";
            isValid = false;
        }

        // minutes
        if (
            formData.actualMinutes === "" ||
            formData.actualMinutes === null
        ) {
            tempErrors.actualMinutes = "Actual Minutes is required";
            isValid = false;
        }

        // minute validation
        if (
            Number(formData.actualMinutes) > 59 ||
            Number(formData.actualMinutes) < 0
        ) {
            tempErrors.actualMinutes =
                "Minutes should be between 0 to 59";

            isValid = false;
        }

        // both zero validation
        if (
            Number(formData.actualHours) === 0 &&
            Number(formData.actualMinutes) === 0
        ) {
            tempErrors.actualHours =
                "Hours and Minutes both cannot be 0";

            tempErrors.actualMinutes =
                "Hours and Minutes both cannot be 0";

            isValid = false;
        }

        setErrors(tempErrors);

        return isValid;
    };

    // submit
    const handleSubmit = () => {
        if (!validateForm()) return;
        const payload = {
            remark: formData.remark,
            actualHours: formData.actualHours,
            actualMinutes: formData.actualMinutes,
        };

        console.log("FINAL PAYLOAD", payload);

        onSubmit(payload);
    };

    return (
        <Modal
            show={show}
            onHide={close}
            centered
            backdrop="static"
        >
            <Modal.Header
                closeButton
                className="mngmodelheader"
            >
                <Modal.Title>
                    <h5 className="mb-0">
                        Complete Task
                    </h5>

                </Modal.Title>

            </Modal.Header>

            <Modal.Body>
                <small className="text-muted">
                    <strong>Task:</strong> {completeTaskInfo?.taskName}
                </small>

                {/* Remark */}
                <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                        Remark
                        <span className="requiredfield">*</span>
                    </Form.Label>

                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Enter remark..."
                        value={formData.remark}
                        onChange={(e) =>
                            handleChange(
                                "remark",
                                e.target.value
                            )
                        }
                    />

                    {
                        errors.remark &&
                        <p className="errMsg">
                            {errors.remark}
                        </p>
                    }
                </Form.Group>

                {/* Hours & Minutes */}
                <Row>

                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="fw-bold">
                                Actual Hours
                                <span className="requiredfield">*</span>
                            </Form.Label>

                            <Form.Control
                                placeholder="HH"
                                value={formData.actualHours}
                                onChange={(e) => {

                                    const value = e.target.value;

                                    if (/^[0-9]*$/.test(value)) {
                                        handleChange(
                                            "actualHours",
                                            value
                                        );
                                    }
                                }}
                            />

                            {
                                errors.actualHours &&
                                <p className="errMsg">
                                    {errors.actualHours}
                                </p>
                            }
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="fw-bold">
                                Actual Minutes
                                <span className="requiredfield">*</span>
                            </Form.Label>

                            <Form.Control
                                placeholder="MM"
                                value={formData.actualMinutes}
                                onChange={(e) => {

                                    const value = e.target.value;

                                    if (
                                        /^[0-9]{0,2}$/.test(value) &&
                                        value <= 59
                                    ) {
                                        handleChange(
                                            "actualMinutes",
                                            value
                                        );
                                    }
                                }}
                            />

                            {
                                errors.actualMinutes &&
                                <p className="errMsg">
                                    {errors.actualMinutes}
                                </p>
                            }
                        </Form.Group>
                    </Col>

                </Row>

            </Modal.Body>

            <Modal.Footer>
                <Button
                    className="primaryBtn"
                    onClick={handleSubmit}
                >
                    Submit
                </Button>

            </Modal.Footer>
        </Modal>
    );
};

export default CompleteTaskModal;